import { defineMessages } from '@jutro/locale';

export default defineMessages({
    PhotosDocumentsYouSentUs: {
        id: 'ml.claim.views.ml-claim-details-docs-sent.Photos & Documents You Sent Us',
        defaultMessage: 'Photos & Documents You Sent Us'
    },
    UploadDocuments: {
        id: 'ml.claim.views.ml-claim-details-docs-sent.Upload documents',
        defaultMessage: 'Upload documents'
    },
});
